module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Bold.4de87d40.woff";